import { colors } from "../../utils/const";

export const styles = {
  sectionContainer: {
    bgcolor: colors.white,
    display: "flex",
    justifyContent: { xs: "flex-start", sm: "space-between" },
    flexWrap: "wrap",
    gap: 5,
  },
  container: (theme) => ({
    display: "flex",
    gap: 1,
    justifyContent: "start",

    alignItems: "center",
    width: "350px",
  }),
  title: (theme) => ({
    color: colors.blue,
    fontSize: { xs: "16px", sm: "20px" },
    textAlign: "initial",
    fontWeight: "bold",
  }),
  description: (theme) => ({
    color: "#404456",
    fontSize: { xs: "12px", sm: "16px" },
    // textAlign: { xs: "center", sm: "initial" },
    textAlign: "initial",
    fontWeight: "300",
  }),
  imgContainer: (theme) => ({
    borderRadius: "50%",
    bgcolor: "#F5f5f6",
    width: "70px",
    height: "70px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
};
